import React from 'react';
import styles from './smoke.module.scss';

function SmokeCanvas({ className, ...props }) {
  return (
    <>
      <canvas {...props} className={`hero-canvas ${styles.canvas} ${className || ''}`} />
      <canvas {...props} className={`hero-canvas ${styles.canvas} ${className || ''}`} />
    </>
  );
}
export default SmokeCanvas;
